export default "__VITE_ASSET__f122e3d4__"